interface TextFieldHelperProps {
  text: string;
}

export const TextFieldHelper = ({ text }: TextFieldHelperProps) => (
  <p
    className="text-semi-xs text-left text-coral-pink font-sans font-normal tracking-normal"
    id="error-helper"
  >
    {text}
  </p>
);
